var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMachineError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_437_4890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.25348 8.77778V5.88889C9.25348 5.12271 9.54833 4.38791 10.0732 3.84614C10.598 3.30436 11.3099 3 12.0521 3H26.0451C26.7874 3 27.4992 3.30436 28.0241 3.84614C28.5489 4.38791 28.8438 5.12271 28.8438 5.88889V26.1111C28.8438 26.8773 28.5489 27.6121 28.0241 28.1539C27.4992 28.6956 26.7874 29 26.0451 29H12.0521C11.3099 29 10.598 28.6956 10.0732 28.1539C9.54833 27.6121 9.25348 26.8773 9.25348 26.1111V23.2222",
    stroke: "#FF4D54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8507 8.77779H6.45486C4.90923 8.77779 3.65625 10.0712 3.65625 11.6667V20.3333C3.65625 21.9288 4.90923 23.2222 6.45486 23.2222H14.8507C16.3963 23.2222 17.6493 21.9288 17.6493 20.3333V11.6667C17.6493 10.0712 16.3963 8.77779 14.8507 8.77779Z",
    stroke: "#FF4D54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8437 11.7823H19.0486",
    stroke: "#FF4D54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8437 20.3333H19.0486",
    stroke: "#FF4D54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5311 15.7328V13.0822",
    stroke: "#FF4D54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5293 18.6562C10.5127 18.6562 10.4962 18.6596 10.4808 18.6662C10.4654 18.6728 10.4515 18.6825 10.4398 18.6947C10.4281 18.707 10.4188 18.7215 10.4126 18.7374C10.4063 18.7533 10.4032 18.7704 10.4034 18.7876C10.4034 18.8137 10.4109 18.8391 10.425 18.8608C10.439 18.8824 10.459 18.8993 10.4823 18.9092C10.5057 18.9191 10.5313 18.9216 10.5561 18.9164C10.5808 18.9112 10.6035 18.8985 10.6213 18.88C10.639 18.8615 10.651 18.8379 10.6558 18.8123C10.6605 18.7868 10.6578 18.7603 10.648 18.7363C10.6381 18.7123 10.6216 18.6919 10.6004 18.6776C10.5793 18.6633 10.5546 18.6559 10.5293 18.6562",
    stroke: "#FF4D54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_437_4890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 32,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachineError);
export default __webpack_public_path__ + "static/media/machine-error.09baf6c912459b8793801d8494c657e7.svg";
export { ForwardRef as ReactComponent };